import React, { useState, useEffect } from "react";
import Section from "./layouts/Section";
import { WebLink, SiteWide } from "./customComponents";
import { useSelector, useDispatch } from 'react-redux';

import { authActions } from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../redux/selectors/index';
import Helper1, { notify, money, customNormalModalStyles } from '../utility/Helper1';
import { homepage } from '../utility/APIRequests';

import Countdown from 'react-countdown';
import copy from 'copy-to-clipboard';
import { staticCountries } from '../utility/countries';
import { Images } from "./customComponents";
import Slider from "react-slick";
import { RiFileCopyLine, RiPhoneLockFill, RiBankFill, RiStackshareLine, RiWallet3Fill, RiArrowGoBackLine, RiEarthLine, RiLockUnlockLine, RiAccountBoxFill, RiSecurePaymentLine, RiListOrdered, RiLockPasswordFill, RiLoginBoxFill, RiMouseLine } from "react-icons/ri";
import { mainStyle, mainColor, header, footer, otherColors } from '../utility/styles';
import QRCode from "react-qr-code";

// Modern UI Icons
import {
    Users,
    Share2,
    Copy,
    QrCode,
    Gift,
    TrendingUp,
    Award,
    Star,
    Link,
    CheckCircle,
    AlertCircle,
    DollarSign,
    Percent,
    UserPlus,
    Sparkles
} from 'lucide-react';

function RefLink({ history }) {

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const [accessCode, setAccessCode] = useState('');
    const [emailOTP, setEmailOTP] = useState('');
    const [loading, setloading] = useState();
    const [loadingText, setLoadingText] = useState('Loading...');
    const [copiedStates, setCopiedStates] = useState({ refId: false, link: false });

    const dispatch = useDispatch();

    const copyRefLink = () => {
        notify('Referral Link Copied', 1)
    }

    const copyToClipboard = (text, type) => {
        copy(text);
        setCopiedStates(prev => ({ ...prev, [type]: true }));
        setTimeout(() => {
            setCopiedStates(prev => ({ ...prev, [type]: false }));
        }, 2000);
        notify('Copied to clipboard!', 1);
    }

    const levelTableDesc = [
        { id: 1, percent: `${site_settings?.plans?.[0]?.childs?.[0]?.ref_earning_1}%`, desc: 'Direct invitee', color: 'from-green-500 to-emerald-600' },
        { id: 2, percent: `${site_settings?.plans?.[0]?.childs?.[0]?.ref_earning_2}%`, desc: 'LV1 invitee', color: 'from-blue-500 to-cyan-600' },
        { id: 3, percent: `${site_settings?.plans?.[0]?.childs?.[0]?.ref_earning_3}%`, desc: 'LV2 invitee', color: 'from-purple-500 to-pink-600' },

    ]
    // const myRefLink = site_settings?.site_settings?.site_url+'/#/signup?ref='+userData?.myrefid
    const myRefLink = site_settings?.site_settings?.site_url + '/signup?ref=' + userData?.myrefid

    return (
        <SiteWide id="main" title={`Invite Your Friends`}>
            <Section loading={loading} overlayText={loadingText} title={'Invite Your Friends'}>
                <div className="min-h-screen p-4 sm:p-6 lg:p-4 sm:p-6 lg:p-8">
                    <div className="max-w-7xl mx-auto pt-4 sm:pt-6 lg:pt-8">
                        {/* Modern Header */}
                        <div className="text-center mb-8 sm:mb-12">
                            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                                Invite Your Friends
                            </h1>
                            <p className="text-lg sm:text-xl text-blue-200 px-4">
                                Earn commissions by referring friends and building your network
                            </p>
                        </div>

                        <div id="mainshiicontent" className="w-full max-w-4xl mx-auto space-y-8">
                            {/* QR Code & Referral ID Section */}
                            <div className="w-full">
                                <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-4 sm:p-6 lg:p-8 shadow-2xl">
                                    <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                                        <QrCode className="mr-3 text-blue-300" />
                                        Share Your Referral
                                    </h2>

                                    {/* QR Code Display */}
                                    <div className="flex flex-col items-center mb-8">
                                        <div className="bg-white p-6 rounded-3xl shadow-2xl mb-6 transform hover:scale-105 transition-transform duration-300">
                                            <QRCode value={myRefLink} size={150} className="sm:w-[200px] sm:h-[200px] w-[150px] h-[150px]" />
                                        </div>
                                        <p className="text-gray-300 text-sm text-center">
                                            Scan this QR code to share your referral link instantly
                                        </p>
                                    </div>

                                    {/* Referral ID */}
                                    <div className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl p-6 border border-blue-400/30">
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-gray-300 text-sm mb-2">Your Referral ID</p>
                                                <p className="text-white font-bold text-xl font-mono">
                                                    {userData?.myrefid}
                                                </p>
                                            </div>
                                            <button
                                                onClick={() => copyToClipboard(userData?.myrefid, 'refId')}
                                                className={`p-3 rounded-2xl transition-all duration-300 transform hover:scale-110 ${copiedStates.refId
                                                        ? 'bg-green-500/20 border border-green-400/30'
                                                        : 'bg-white/10 border border-white/20 hover:bg-white/20'
                                                    }`}
                                            >
                                                {copiedStates.refId ? (
                                                    <CheckCircle className="text-green-400" size={20} />
                                                ) : (
                                                    <Copy className="text-white" size={20} />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Referral Link & Commission Info */}
                            <div className="w-full">
                                <div className="space-y-8">
                                    {/* Referral Link */}
                                    <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-4 sm:p-6 lg:p-8 shadow-2xl">
                                        <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                                            <Link className="mr-3 text-green-300" />
                                            Referral Link
                                        </h2>

                                        <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 rounded-2xl p-6 border border-green-400/30 mb-6">
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1 min-w-0">
                                                    <p className="text-gray-300 text-sm mb-2">Your Referral Link</p>
                                                    <p className="text-white font-mono text-sm break-all">
                                                        {myRefLink}
                                                    </p>
                                                </div>
                                                <button
                                                    onClick={() => { copy(myRefLink); copyRefLink(); }}
                                                    className={`ml-4 p-3 rounded-2xl transition-all duration-300 transform hover:scale-110 ${copiedStates.link
                                                            ? 'bg-green-500/20 border border-green-400/30'
                                                            : 'bg-white/10 border border-white/20 hover:bg-white/20'
                                                        }`}
                                                >
                                                    {copiedStates.link ? (
                                                        <CheckCircle className="text-green-400" size={20} />
                                                    ) : (
                                                        <Copy className="text-white" size={20} />
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        <button
                                            onClick={() => { copy(myRefLink); copyRefLink(); }}
                                            className="w-full py-4 px-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl text-white font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-green-500/25 flex items-center justify-center gap-3"
                                        >
                                            <Share2 size={20} />
                                            Copy Invitation Link
                                        </button>
                                    </div>

                                    {/* Commission Rules */}
                                    <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-4 sm:p-6 lg:p-8 shadow-2xl">
                                        <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                                            <Gift className="mr-3 text-yellow-300" />
                                            Commission Rules
                                        </h2>

                                        {1 > 2 && <div className="mb-6">
                                            <div className="bg-gradient-to-r from-yellow-500/10 to-orange-500/10 rounded-2xl p-4 border border-yellow-400/30">
                                                <div className="flex items-start">
                                                    <AlertCircle className="text-yellow-300 mt-1 mr-3 flex-shrink-0" size={20} />
                                                    <div>
                                                        <p className="text-white text-sm leading-relaxed">
                                                            <strong>Commission Rebating:</strong> For every profit earned by a friend after registering, you will receive a corresponding percentage of commission.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                        <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                                            <TrendingUp className="mr-3 text-blue-300" />
                                            Commission Rate Structure
                                        </h3>

                                        <div className="space-y-4">
                                            {levelTableDesc.map((item, index) => (
                                                <div
                                                    key={item.id}
                                                    className={`bg-gradient-to-r ${item.color} rounded-2xl p-6 border border-white/20 transform hover:scale-105 transition-all duration-300`}
                                                >
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center">
                                                            <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center mr-4">
                                                                <Award className="text-white" size={24} />
                                                            </div>
                                                            <div>
                                                                <h4 className="text-white font-bold text-lg">Level {item.id}</h4>
                                                                <p className="text-white/80 text-sm">{item.desc}</p>
                                                            </div>
                                                        </div>
                                                        <div className="text-right">
                                                            <div className="bg-white/20 rounded-xl px-4 py-2">
                                                                <p className="text-white font-bold text-2xl">{item.percent}</p>
                                                                <p className="text-white/80 text-xs">Commission</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </Section>
        </SiteWide>
    );
}

export default RefLink;